import React, { useState } from "react"
import { Checkbox, Flex, Box, useOutsideClick } from "@chakra-ui/react"
import { colors } from "@app/theme/colors"
import Icon from "@components/Icon/Icon"
import Swatch from "./Swatch"

const FilterList: React.FC = (filter: any) => {
  const ref = React.useRef()
  const [isOpen, setIsOpen] = useState(false)

  useOutsideClick({
    ref: ref,
    handler: () => setIsOpen(false),
  })

  const buildTextLabel = (label: string, replace: boolean) => {
    const sizeMap = {
      "1KG": "1kg (0000000)",
      "2KG": "2kg (000000)",
      "3KG": "3kg (00000)",
      "4KG": "4kg (0000)",
      "0000": "NB (0000)",
      "000": "0-3m (000)",
      "00": "3-6m (00)",
      "6-12m": "6-12m (0)",
      0: "6-12m (0)",
      1: "12-18m (1)",
      2: "18-24m (2)",
    }

    if (typeof label === "number") {
      return label
    }

    if (sizeMap[label]) {
      return sizeMap[label]
    }

    if (replace) {
      return label.replace(/-/g, " ")
    }

    return label
  }

  return (
    <Flex position="relative" mr={1} ref={ref}>
      <Flex
        fontSize="15px"
        fontWeight={"medium"}
        alignItems={"center"}
        borderRadius="5px"
        px="16px"
        py={"8px"}
        onClick={() => setIsOpen(!isOpen)}
        cursor="pointer"
        border={`1px solid ${colors.brand.border}`}
        color={filter.filterListProps.options.filter(option => option.checked).length ? "white" : ""}
        bg={
          filter.filterListProps.options.filter(option => option.checked).length
            ? colors.brand.navy.dark
            : isOpen
            ? colors.brand.beige.light
            : "white"
        }
      >
        {filter?.filter?.name}

        <Box transform={isOpen ? "rotateX(180deg)" : "rotateX(0deg)"}>
          <Icon
            color={filter.filterListProps.options.filter(option => option.checked).length ? "white" : "black"}
            ml="10px"
            name="chevronDown"
            size="14px"
          ></Icon>
        </Box>
      </Flex>
      {isOpen && (
        <Flex
          zIndex={6}
          bg={"white"}
          px={2}
          py={1}
          border={`1px solid ${colors.brand.border}`}
          borderRadius="5px"
          flexDirection={"column"}
          position="absolute"
          top={"100%"}
          left={0}
          maxHeight={"400px"}
          overflow={"auto"}
        >
          {filter.filterListProps.options.map((option: any) => (
            <Flex
              onClick={() => {
                filter.filterListProps.handleChange(option.key)
              }}
              textTransform={"capitalize"}
              py={1}
              cursor="pointer"
              key={option?.key}
              fontWeight="medium"
              whiteSpace={"nowrap"}
              fontSize={"12px"}
            >
              {filter?.filter?.displayView === "swatch" ? (
                <Swatch {...option} />
              ) : (
                <Checkbox pointerEvents={"none"} isChecked={option.checked} mr={1}></Checkbox>
              )}
              {buildTextLabel(option.key, filter?.filter?.name === "Benefits")}
            </Flex>
          ))}
        </Flex>
      )}
    </Flex>
  )
}

export default FilterList
